import { FaServer, FaExchangeAlt, FaArrowRight, FaArrowLeft, FaSkull, FaVolumeMute, FaVolumeUp } from "react-icons/fa";
import { ImHammer2 } from "react-icons/im";

const LogTypesSCP = [
    { id : 0, name: "Server Log", getIcon: () => <FaServer size={"35px"} className="text-blue-500"/> },
    { id : 1, name: "Player Joined", getIcon: () => <FaArrowRight size={"35px"} className="text-green-500"/> },
    { id : 2, name: "Player Left", getIcon: () => <FaArrowLeft size={"35px"} className="text-red-400"/> },
    { id : 3, name: "Ban", getIcon: () => <ImHammer2 size={"35px"} className="text-red-700"/> },
    { id : 4, name: "RA Command Used", getIcon: () => <></> },
    { id : 5, name: "User Reports", getIcon: () => <></> },
    { id : 6, name: "Player Role Changed", getIcon: () => <FaExchangeAlt size={"35px"} className="text-yellow-200"/> },
    { id : 7, name: "Player Killed", getIcon: () => <FaSkull size={"35px"} className="text-red-500"/> },
    { id : 8, name: "Player Damaged", getIcon: () => <></> },
    { id : 9, name: "Command Used", getIcon: () => <></> },
    { id : 10, name: "Mute", getIcon: () => <FaVolumeMute size={"35px"} className="text-red-400"/> },
    { id : 11, name: "Unmute", getIcon: () => <FaVolumeUp size={"35px"} className="text-green-400"/> },
    { id : 12, name: "Kick", getIcon: () => <></> },
];


export default LogTypesSCP;